import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { OFFER_ANCHOR } from '../../data/site';
import { easeOutStrong } from '../../utils/format';
const HIDE_ZONES = ['hero', 'look-inside', 'offer-details', 'final-cta'];
function isInView(el: HTMLElement | null): boolean {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

/** Mobile-only bar that always leads to the offer. Hidden over the hero, previews, offer, final block and footer. */
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const footer = document.querySelector('footer');
      const hidden = HIDE_ZONES.some(id => isInView(document.getElementById(id))) || isInView(footer);
      setVisible(prev => prev === !hidden ? prev : !hidden);
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return <AnimatePresence data-id="element-65" data-mp="avanmmji3jd8">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: easeOutStrong
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-ink md:hidden" style={{
      paddingBottom: 'env(safe-area-inset-bottom)'
    }} data-id="element-66" data-mp="aw3xhwdraozl">
          <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-67" data-mp="1w8nht3bjrid3">
            <div className="min-w-0 text-white" data-id="element-68" data-mp="1r914ktvpy24a">
              <p className="font-display text-[24px] font-bold leading-none" data-id="element-69" data-mp="1rac7krhcb5uc">
                $27 <span className="text-sm text-white/70" data-id="element-70" data-mp="3lozgj6v9epli">USD</span>
              </p>
              <p className="mt-1 truncate text-[13px] text-white/70" data-id="element-71" data-mp="3qfpqkxemrgmj">Lesson plans + 5 bonuses</p>
            </div>
            <a href={OFFER_ANCHOR} className="inline-flex h-12 shrink-0 items-center rounded-[14px] bg-go px-5 font-display text-[20px] font-bold uppercase text-ink shadow-[0_4px_0_#5E7F2A] transition-colors duration-150 hover:bg-go-hover" data-id="element-72" data-mp="3bruv5998my5r">
              See the offer
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}